import { useEffect } from "react";
import { type AppEnvironment, useEnv } from "@/core/env";

const APP_ENV_TO_TITLE = {
  development: "Volca (Dev)",
  staging: "Volca (Staging)",
  demo: "Volca (Demo)",
  production: "Volca",
} as const;

const getTitle = (env: AppEnvironment) => APP_ENV_TO_TITLE[env];

export const useDocumentTitle = () => {
  const { appEnv } = useEnv();

  useEffect(() => {
    document.title = getTitle(appEnv);
  }, [appEnv]);
};
